var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button button--icon",
      class: _vm.buttonClass,
      attrs: { type: "button", disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.scrollTo(_vm.scrollPosition)
        },
      },
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _vm.name
        ? _c("icon", { attrs: { name: _vm.name, size: _vm.size } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }